<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("profile.change_password") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("profile.change_password") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("profile.password_new")
              }}</label>
              <div class="col-md-10">
                <base-input type="password" placeholder="" v-model="password"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="example-email-input"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.password_confirm") }}</label
              >
              <div class="col-md-10">
                <base-input
                  type="password"
                  autocomplete=""
                  placeholder=""
                  id="password_confirm"
                  v-model="password_confirm"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="offset-md-2 col-md-10">
                <base-button type="primary" @click="handleUpdate()" disabled v-if="(password != password_confirm || password.length <= 4) ? true : false">{{ $t("save") }}</base-button> 
                <base-button type="primary" @click="handleUpdate()"  v-if="password == password_confirm && password.length > 4">{{ $t("save") }}</base-button> 
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import numbers from "./numbers";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNumber",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      corporate: "Corporate/getData"
    })
  },
  data() {
    return {
      optionChargeNumber: [
        {
          label: this.$t("menu.pilot_number"),
          value: 1
        },
        {
          label: this.$t("menu.agent_number"),
          value: 2
        }
      ],

        password: "",
        password_confirm: ""
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      changePassword: "Auth/changePassword"
    }),

    handleUpdate() {
      this.changePassword({
        password : this.password,
        confirm_password :this.password_confirm
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("profile.change_password_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t("errors.profile.change_password_failed"),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
